export default function TrackerException(code, message) {
  this.code = code;
  this.message = message;
}
